<template>
	<q-page padding>
		<div class="row gutter-md" >
			<div class="col-xs-12 col-sm-6 col-md-6 col-lg-5 col-xl-4">
				<!-- <q-btn
					:label="$t('show_overview_data')"
					color="secondary"
					icon="fal fa-chart-area"
					class="full-width"
					@click="showDashboardModal()"
					:disable="!loaded_data"
				/> -->
			</div>

			<div class="col-12" v-if="showReportPannel && userHasReports">
				<q-collapsible group="somegroup" v-model="open" class="accordion-modify">
					<template slot="header" class="bg-secondary" style="padding: 0;" >
						<q-card-title class="bg-secondary" style="width: 100%; padding: 10px;">
							<span class="text-white q-headline" >
								<q-icon name="fal fa-file-chart-line" />
								{{ $t('business_inteligence') }}
							</span>
						</q-card-title>
					</template>

						

					<q-card-separator style="padding: 0;" />

					<q-item-main>
						<q-tabs
							v-model="tab"
							color="secondary"
							class="shadow-1"
							@select="loadReports"
						>
							<q-tab
								v-for="(report, index) in reports"
								slot="title"
								:name="report"
								:label="$t(report)"
								v-if="showModule(report)"
								:key="`t${index}`"
								:default="getDefault(report)"
							/>

							<q-tab-pane
								v-for="(report, index) in reports"
								:name="report"
								class="q-px-lg q-pb-lg"
								v-if="showModule(report)"
								:key="`tp${index}`"
							>
								<q-list highlight separator link>
									<q-item
										v-for="(report, index) in report_list"
										:key="`i${index}`"
										@click.native="showReport(report)"
										v-if="report_list.length > 0"
									>
										<q-item-main>
											{{ $t(report.slug) }}
										</q-item-main>
									</q-item>

									<q-item v-if="report_list.length === 0">
										<q-item-main>
											{{ $t('no_report_available') }}
										</q-item-main>
									</q-item>
								</q-list>
							</q-tab-pane>
						</q-tabs>
					</q-item-main>
				</q-collapsible>
			</div>
		</div>

		<div class="q-mt-lg" v-if="showMyAcademy && report">
			<iframe
				style="width: 100%; height: 80vh; margin-top: 5px;"
				:src="report.url_original"
				frameborder="0"
			></iframe>
		</div>

		<div class="row gutter-md q-mt-md" v-if="data_studio_dashboards.length > 0">
			<div class="col-12" v-for="(report, index) in data_studio_dashboards" :key="index">
				<iframe style="width: 100%; height: 90vh;" :src="report.url" frameborder="0">
				</iframe>
			</div>
		</div>

		<q-modal
			v-model="show_report"
			:content-css="{ minWidth: '100vw', maxWidth: '100vw', minHeight: '100vh' }"
		>
			<q-modal-layout>
				<q-toolbar slot="header">
					<q-btn flat round dense @click="show_report = false" icon="fas fa-times" />
					<q-toolbar-title>
						{{ $t('reports') }}
					</q-toolbar-title>
				</q-toolbar>

				<div class="layout-padding">
					<div style="position:relative; width:100%; height:0px; padding-bottom:56.25%;">
						<iframe
							style="position:absolute; left:0; top:0; width:100%; height:100%"
							:src="report_url"
							frameborder="0"
						>
						</iframe>
					</div>
				</div>
			</q-modal-layout>
		</q-modal>

		<dashboard
			v-if="show_dashboard_modal"
			v-show="show_dashboard_modal"
			:showModule="showModule"
			@hide_dashboard_modal="hideDashboardModal()"
		/>
	</q-page>
</template>

<script>
import { mapGetters } from 'vuex'

export default {
	i18nOptions: {
		namespaces: ['custom', 'overview', 'common', 'training', 'courses', , 'admin', 'users'],
	},

	name: 'AdminOverview',

	components: {
		dashboard: () => import('components/admin/overview/Dashboard'),
	},

	data() {
		return {
			reports: [
				'users',
				'online',
				'live_classes',
				'presential',
				'trails',
				'webcasts',
				'podcasts',
				'surveys',
				'library',
				'management',
			],
			tab: '',
			report_list: [],
			show_report: false,
			report_url: '',
			loaded_data: false,
			show_dashboard_modal: false,
			data_studio_dashboards: [],
			open: true
		}
	},

	computed: {
		...mapGetters({
			access_token: 'common/access_token',
			reload_content: 'common/reload_content',
			id_user_client_selected: 'common/id_user_client_selected',
			clients: 'params/clients',
			user_module_items: 'common/user_module_items',
			reports_store: 'registration_lists/reports',
		}),

		getHeader() {
			let headers = {}
			return (headers = {
				headers: {
					'content-type': 'application/json',
					authorization:
						'Basic ' +
						btoa(process.env.APP_CLIENT_ID + ':' + process.env.APP_CLIENT_SECRET),
					authorization: 'Bearer ' + this.access_token,
				},
			})
		},

		showReportPannel() {
			let obj = this.user_module_items.find((obj) => {
				return obj.slug === 'reports_panel'
			})
			if (obj) return obj.permission
			else return false
		},

		userHasReports() {
			if (this.reports_store.length > 0) return true
			else return false
		},

		report() {
			return this.reports_store.find((report) => report.slug === 'my_academy')
		},

		showMyAcademy() {
			let obj = this.user_module_items.find((obj) => {
				return obj.slug === 'my_academy'
			})
			if (obj) return obj.permission
			else return false
		}
	},

	methods: {
		fetchListsBI() {
			this.$axios
				.get('/accounts/get_registration_lists/', this.getHeader)
				.then((response) => {
					this.$store.dispatch('registration_lists/SET_LISTS', [response.data])
					this.loadReports()
					this.loadDataStudioDashboards()
				})
				.catch((e) => {
					console.log(e)
				})
				.finally(() => {
					this.loaded_data = true
					this.$q.loading.hide()
				})
		},

		toggle() {
			this.open = !this.open
		},


		showModule(module) {
			let client = this.clients.find((obj) => {
				return obj.id === this.id_user_client_selected
			})
			if (client) {
				switch (module) {
					case 'online':
					case 'courses':
						return client.has_courses
					case 'trails':
						return client.has_trails
					case 'library':
						return client.has_library
					case 'webcasts':
						return client.has_webcasts
					case 'presential_trainings':
					case 'presential':
						return client.has_presential
					case 'podcasts':
						return client.has_podcasts
					case 'library':
						return client.has_library
					case 'live_classes':
						return client.has_live_classes
					case 'management':
						return true
					case 'surveys':
						return this.user_module_items.find((e) => e.slug === 'surveys').permission
					case 'users':
						return this.user_module_items.find((e) => e.slug === 'users_manage')
							.permission
					default:
						return false
				}
			} else return false
		},

		getDefault(module) {
			if (!this.tab) {
				if (this.showModule(module)) {
					this.tab = module
					this.loadReports()
					return true
				} else return false
			}
		},

		loadReports() {
			let slug_type = ''
			
			if (this.tab === 'users') slug_type = 'users'
			else if (this.tab === 'stores') slug_type = 'stores'
			else if (this.tab === 'online') slug_type = 'group_trainings'
			else if (this.tab === 'live_classes') slug_type = 'live_classes'
			else if (this.tab === 'trails') slug_type = 'trails'
			else if (this.tab === 'library') slug_type = 'library_files'
			else if (this.tab === 'webcasts') slug_type = 'webcasts'
			else if (this.tab === 'podcasts') slug_type = 'podcasts'
			else if (this.tab === 'presential') slug_type = 'presential_trainings'
			else if (this.tab === 'surveys') slug_type = 'surveys'
			else if (this.tab === 'management') slug_type = 'management'
			if (this.reports_store)
				this.report_list = this.reports_store.filter((obj) => {
					return (
						obj.slug_type === slug_type &&
						obj.url != 'https://www.take5.com.br' &&
						obj.url != ''
					)
				})
		},

		getAuthParamsData(url_original) {
			this.$q.loading.show()
			this.$axios
				.get('/reports/reports/get_looker_studio_challenge_token/', this.getHeader)
				.then((response) => {
					this.report_url = `${url_original}?${response.data.params}`
					this.show_report = true
				})
				.catch((e) => {
					console.log(e)
				})
				.finally(() => {
					this.$q.loading.hide()
				})
		},

		showReport(report) {
			if (report.report_type === 3) {
				this.getAuthParamsData(report.url_original)
			} else {
				this.report_url = report.url
				this.show_report = true
			}
		},

		showDashboardModal() {
			this.show_dashboard_modal = true
		},

		hideDashboardModal() {
			this.show_dashboard_modal = false
		},

		loadDataStudioDashboards() {
			
			if (this.reports_store)
				this.data_studio_dashboards = this.reports_store.filter((obj) => {
					return (
						obj.slug_type === 'index' &&
						obj.url != 'https://www.take5.com.br' &&
						obj.url != ''
					)
				})
		},
		
	},

	watch: {
		reload_content: function() {
			this.show_dashboard_modal = false
			this.fetchListsBI()
		},
	},

	created() {
		if (this.showMyAcademy && !!this.report === false) {
			this.open = false
		}
		this.fetchListsBI()
	},
}
</script>

<style>

	.accordion-modify{
		padding: 0; 
		box-shadow: 0 1px 5px #00000033,0 2px 2px #00000024,0 3px 1px -2px #0000001f;
	}
	.accordion-modify .q-item-division{
		background-color: var(--q-color-secondary)
	}
	.accordion-modify .q-collapsible-sub-item{
		background-color: #fff
	}
	.accordion-modify .q-collapsible-sub-item .q-item-division{
		background-color: #fff
	}

</style>
